import { jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import * as ReactPage from "../../../state/react-page";
import { useReactRuntime } from "../hooks/use-react-runtime";
import { StoreContext } from "../hooks/use-store";
function LiveProvider({ children }) {
  const runtime = useReactRuntime();
  const store = useMemo(
    () => ReactPage.configureStore({
      name: "Host store",
      preloadedState: runtime.store.getState()
    }),
    [runtime]
  );
  return /* @__PURE__ */ jsx(StoreContext.Provider, { value: store, children });
}
export {
  LiveProvider as default
};
//# sourceMappingURL=LiveProvider.js.map